import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CxModalInstance } from 'app/shared/cx-modal/cx-modal-instance.service';

@Component({
  selector: 'app-ctd-receive-success-dialog',
  templateUrl: './ctd-receive-success-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CxModalInstance],
})
export class CtdReceiveSuccessDialogComponent {
  @Input()
  public orderCode!: string;
}
